export default "__VITE_ASSET__BD7Pj$Cm__"